// material-ui
import { Button, FormControl, FormHelperText, Grid, InputLabel, Select, Stack, MenuItem, TextField } from '@mui/material';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';

// third-party
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSearchParams } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';

/**
 * 'Enter your age'
 * yup.number Expected 0 arguments, but got 1 */
const validationSchema = yup.object({
    status: yup.string().optional(),
    store: yup.string().optional(),
    process: yup.string().optional()
});

// ==============================|| FORM VALIDATION - LOGIN FORMIK  ||============================== //

const ProcessFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const formik = useFormik({
        initialValues: {
            status: searchParams.get('status') || '',
            storeId: searchParams.get('storeId') || ''
        },
        validationSchema,
        onSubmit: (params: { process?: string; storeId?: string; status?: string; dateRangeInit?: string; dateRangeEnd?: string }) =>
            setSearchParams({
                ...Object.fromEntries(new URLSearchParams(searchParams)),
                ...params
            })
    });

    return (
        <MainCard title="Filter">
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={gridSpacing} sx={{ maxWidth: 280 }}>
                    {/* <Grid item xs={12}>
                        <FormControl sx={{ m: 1, minWidth: 240 }}>
                            <InputLabel id="process-select">Process</InputLabel>
                            <Select
                                labelId="process-select"
                                id="process"
                                name="process"
                                value={formik.values.process}
                                onChange={formik.handleChange}
                                label="Process"
                            >
                                <MenuItem value="All">
                                    <em>All</em>
                                </MenuItem>
                                <MenuItem value="INVENTORY">INVENTORY</MenuItem>
                                <MenuItem value="PRICES">PRICES</MenuItem>
                            </Select>
                            {formik.errors.status && (
                                <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {formik.errors.status}{' '}
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid> */}
                    <Grid item xs={12}>
                        <FormControl sx={{ m: 1, minWidth: 240 }}>
                            <InputLabel id="process-select">Status</InputLabel>
                            <Select
                                labelId="status-select"
                                id="status"
                                name="status"
                                value={formik.values.status}
                                onChange={formik.handleChange}
                                label="Status"
                            >
                                <MenuItem value="">
                                    <em>All</em>
                                </MenuItem>
                                <MenuItem value="INITIALIZING">INITIALIZING</MenuItem>
                                <MenuItem value="ERROR">ERROR</MenuItem>
                                <MenuItem value="PROCESSING">PROCESSING</MenuItem>
                                <MenuItem value="FINALIZED">FINALIZED</MenuItem>
                            </Select>
                            {formik.errors.status && (
                                <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {formik.errors.status}
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl sx={{ m: 1, minWidth: 240 }}>
                            <TextField
                                label="Store Id"
                                id="storeId"
                                name="storeId"
                                value={formik.values.storeId}
                                onChange={formik.handleChange}
                            />
                            {formik.errors.status && (
                                <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {formik.errors.status}
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction="row" justifyContent="flex-end">
                            <AnimateButton>
                                <Button variant="contained" type="submit">
                                    Submit
                                </Button>
                            </AnimateButton>
                        </Stack>
                    </Grid>
                </Grid>
            </form>
        </MainCard>
    );
};

export default ProcessFilters;
